/* Klinaly : page d'attente. Tissu qui révèle le motif croco sous « l'eau » (souris ou doigt),
   curseur personnalisé, effet aimant et compte à rebours. */
(() => {
  if (window.KlinalyTeaserLoaded) return;
  window.KlinalyTeaserLoaded = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);

  function seeded(seed) {
    let a = seed >>> 0;
    return () => {
      a = (a + 0x6d2b79f5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function roundRect(g, x, y, w, h, r) {
    r = Math.max(0, Math.min(r, w / 2, h / 2));
    g.beginPath();
    g.moveTo(x + r, y);
    g.arcTo(x + w, y, x + w, y + h, r);
    g.arcTo(x + w, y + h, x, y + h, r);
    g.arcTo(x, y + h, x, y, r);
    g.arcTo(x, y, x + w, y, r);
    g.closePath();
  }

  function sizeCanvas(c, w, h, dpr) {
    c.width = Math.max(1, Math.round(w * dpr));
    c.height = Math.max(1, Math.round(h * dpr));
    const g = c.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    return g;
  }

  function drawCover(g, img, w, h) {
    const ir = img.naturalWidth / img.naturalHeight;
    const r = w / h;
    let dw = w;
    let dh = h;
    if (ir > r) dw = h * ir;
    else dh = w / ir;
    g.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
  }

  // Éclaircit une photo très sombre en la superposant à elle-même (fonctionne sur tous les navigateurs).
  function drawCoverBoosted(g, img, w, h, boost) {
    drawCover(g, img, w, h);
    let extra = boost - 1;
    if (!(extra > 0)) return;
    g.save();
    g.globalCompositeOperation = 'lighter';
    while (extra > 0) {
      g.globalAlpha = Math.min(1, extra);
      drawCover(g, img, w, h);
      extra -= 1;
    }
    g.restore();
  }

  // Pinceau doux réutilisé pour dessiner « l'eau » dans le masque.
  const BRUSH = (() => {
    const c = document.createElement('canvas');
    c.width = c.height = 128;
    const g = c.getContext('2d');
    const grad = g.createRadialGradient(64, 64, 0, 64, 64, 64);
    grad.addColorStop(0, 'rgba(255,255,255,1)');
    grad.addColorStop(0.55, 'rgba(255,255,255,0.85)');
    grad.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = grad;
    g.fillRect(0, 0, 128, 128);
    return c;
  })();

  // Tissu sec : nylon noir, trame ripstop discrète et reflet.
  function paintNylon(c, w, h, dpr) {
    const g = sizeCanvas(c, w, h, dpr);
    g.fillStyle = '#0c0c0d';
    g.fillRect(0, 0, w, h);

    g.strokeStyle = 'rgba(255,255,255,0.022)';
    g.lineWidth = 1;
    g.beginPath();
    for (let x = 0.5; x < w; x += 7) {
      g.moveTo(x, 0);
      g.lineTo(x, h);
    }
    for (let y = 0.5; y < h; y += 7) {
      g.moveTo(0, y);
      g.lineTo(w, y);
    }
    g.stroke();

    const sheen = g.createLinearGradient(0, 0, w, h);
    sheen.addColorStop(0, 'rgba(255,255,255,0)');
    sheen.addColorStop(0.42, 'rgba(255,255,255,0.04)');
    sheen.addColorStop(0.5, 'rgba(255,255,255,0.07)');
    sheen.addColorStop(0.6, 'rgba(255,255,255,0.02)');
    sheen.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = sheen;
    g.fillRect(0, 0, w, h);

    const v = g.createRadialGradient(w / 2, h / 2, Math.min(w, h) * 0.2, w / 2, h / 2, Math.max(w, h) * 0.75);
    v.addColorStop(0, 'rgba(0,0,0,0)');
    v.addColorStop(1, 'rgba(0,0,0,0.45)');
    g.fillStyle = v;
    g.fillRect(0, 0, w, h);
  }

  // Tissu mouillé : écailles de croco (utilisé tant qu'aucune photo n'est choisie).
  // Grandes écailles rectangulaires au centre, plus petites et plus rondes vers les bords, comme un ventre de croco.
  function paintCroco(c, w, h, dpr) {
    const g = sizeCanvas(c, w, h, dpr);
    g.fillStyle = '#050506';
    g.fillRect(0, 0, w, h);

    const rand = seeded(1987);
    const unit = clamp(Math.min(w, h) / 7, 30, 86);
    const rgb = (r, gr, b) => `rgb(${r | 0},${gr | 0},${b | 0})`;
    let y = -unit * 0.5;
    while (y < h + unit) {
      const d = clamp(Math.abs(y + unit * 0.4 - h / 2) / (h / 2), 0, 1.2);
      const k = 1 - 0.45 * Math.min(d, 1);
      const rowH = unit * k * (0.8 + rand() * 0.3);
      const roundness = 0.14 + 0.32 * Math.min(d, 1);
      let x = -rand() * unit;
      while (x < w + unit) {
        const sw = unit * k * (0.75 + rand() * 1.15);
        const gap = Math.max(2, unit * 0.055 * (0.8 + rand() * 0.5));
        const rx = x + gap / 2;
        const ry = y + gap / 2;
        const rw = sw - gap;
        const rh = rowH - gap;
        const rad = Math.min(rw, rh) * (roundness + rand() * 0.1);
        const tone = 28 + rand() * 18;

        roundRect(g, rx, ry, rw, rh, rad);
        g.fillStyle = rgb(tone, tone + 1, tone + 4);
        g.fill();

        g.save();
        roundRect(g, rx, ry, rw, rh, rad);
        g.clip();
        const top = g.createLinearGradient(0, ry, 0, ry + rh * 0.4);
        top.addColorStop(0, 'rgba(255,255,255,0.13)');
        top.addColorStop(1, 'rgba(255,255,255,0)');
        g.fillStyle = top;
        g.fillRect(rx, ry, rw, rh * 0.4);
        const bottom = g.createLinearGradient(0, ry + rh * 0.55, 0, ry + rh);
        bottom.addColorStop(0, 'rgba(0,0,0,0)');
        bottom.addColorStop(1, 'rgba(0,0,0,0.4)');
        g.fillStyle = bottom;
        g.fillRect(rx, ry + rh * 0.55, rw, rh * 0.45);
        g.fillStyle = 'rgba(0,0,0,0.18)';
        const pores = 3 + Math.floor(rand() * 5);
        for (let i = 0; i < pores; i++) {
          g.beginPath();
          g.arc(rx + rand() * rw, ry + rh * (0.25 + rand() * 0.6), 0.6 + rand() * 1.1, 0, Math.PI * 2);
          g.fill();
        }
        g.restore();

        // Certaines grandes écailles sont fendues en deux, comme sur le vrai cuir.
        if (rw > unit * 1.3 && rand() < 0.35) {
          const sx = rx + rw * (0.35 + rand() * 0.3);
          g.strokeStyle = 'rgba(5,5,6,0.9)';
          g.lineWidth = gap * 0.7;
          g.lineCap = 'round';
          g.beginPath();
          g.moveTo(sx, ry + rh * 0.12);
          g.lineTo(sx + (rand() - 0.5) * 6, ry + rh * 0.88);
          g.stroke();
        }

        x += sw;
      }
      y += rowH;
    }

    const wet = g.createLinearGradient(0, h, w, 0);
    wet.addColorStop(0, 'rgba(120,140,255,0.05)');
    wet.addColorStop(0.5, 'rgba(255,255,255,0.03)');
    wet.addColorStop(1, 'rgba(120,140,255,0.04)');
    g.fillStyle = wet;
    g.fillRect(0, 0, w, h);
  }

  class KlinalyFabric extends HTMLElement {
    connectedCallback() {
      if (this.inited) return;
      this.canvas = this.querySelector('.k-fabric__canvas');
      if (!this.canvas || !this.canvas.getContext) return;
      this.inited = true;

      this.ctx = this.canvas.getContext('2d');
      this.base = document.createElement('canvas');
      this.pattern = document.createElement('canvas');
      this.layer = document.createElement('canvas');
      this.lctx = this.layer.getContext('2d');
      this.mask = document.createElement('canvas');
      this.mctx = this.mask.getContext('2d');
      this.images = {};
      this.drops = [];
      this.ripples = [];
      this.last = null;
      this.raf = 0;
      this.rz = 0;
      this.w = 0;
      this.h = 0;
      this.visible = false;
      this.introDone = false;
      this.lastActivity = performance.now();
      this.nextRain = 0;

      this.onMove = this.onMove.bind(this);
      this.onDown = this.onDown.bind(this);
      this.onLeave = () => {
        this.last = null;
      };
      this.addEventListener('pointermove', this.onMove, { passive: true });
      this.addEventListener('pointerdown', this.onDown, { passive: true });
      this.addEventListener('pointerleave', this.onLeave);
      this.addEventListener('pointercancel', this.onLeave);

      this.ro = new ResizeObserver(() => this.scheduleResize());
      this.ro.observe(this);
      this.io = new IntersectionObserver((entries) => {
        this.visible = entries[entries.length - 1].isIntersecting;
        if (this.visible) {
          this.kick();
          if (!this.introDone) this.intro();
        }
      });
      this.io.observe(this);

      this.load('pattern', this.dataset.pattern);
      this.load('base', this.dataset.base);
      this.resize();

      if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
        setTimeout(() => this.burst(), 500);
      }
    }

    disconnectedCallback() {
      if (!this.inited) return;
      this.inited = false;
      this.removeEventListener('pointermove', this.onMove);
      this.removeEventListener('pointerdown', this.onDown);
      this.removeEventListener('pointerleave', this.onLeave);
      this.removeEventListener('pointercancel', this.onLeave);
      this.ro.disconnect();
      this.io.disconnect();
      cancelAnimationFrame(this.raf);
      cancelAnimationFrame(this.rz);
      this.raf = 0;
      this.rz = 0;
    }

    load(key, url) {
      if (!url) return;
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => {
        this.images[key] = img;
        this.paint();
        this.kick();
      };
      img.src = url;
    }

    scheduleResize() {
      if (this.rz) return;
      this.rz = requestAnimationFrame(() => {
        this.rz = 0;
        this.resize();
      });
    }

    resize() {
      const rect = this.getBoundingClientRect();
      const w = Math.max(1, Math.round(rect.width));
      const h = Math.max(1, Math.round(rect.height));
      if (w === this.w && h === this.h) return;
      this.w = w;
      this.h = h;
      this.dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      this.canvas.width = Math.round(w * this.dpr);
      this.canvas.height = Math.round(h * this.dpr);
      this.layer.width = this.canvas.width;
      this.layer.height = this.canvas.height;
      this.ms = 0.25;
      this.mask.width = Math.ceil(w * this.ms);
      this.mask.height = Math.ceil(h * this.ms);
      this.paint();
      this.kick();
    }

    paint() {
      if (!this.w) return;
      const { w, h, dpr } = this;
      if (this.images.base) drawCover(sizeCanvas(this.base, w, h, dpr), this.images.base, w, h);
      else paintNylon(this.base, w, h, dpr);
      if (this.images.pattern) {
        const boost = clamp(parseFloat(this.dataset.patternBoost) || 1, 1, 4);
        drawCoverBoosted(sizeCanvas(this.pattern, w, h, dpr), this.images.pattern, w, h, boost);
      } else paintCroco(this.pattern, w, h, dpr);
    }

    radius() {
      return clamp(Math.min(this.w, this.h) * 0.085, 26, 72);
    }

    point(e) {
      const rect = this.getBoundingClientRect();
      return { x: e.clientX - rect.left, y: e.clientY - rect.top };
    }

    addDrop(x, y, r, life) {
      this.drops.push({ x, y, r, life, t: performance.now() });
      if (this.drops.length > 600) this.drops.splice(0, this.drops.length - 600);
    }

    onMove(e) {
      if (!e.isPrimary) return;
      const p = this.point(e);
      const r = this.radius();
      this.lastActivity = performance.now();
      if (this.last) {
        const dx = p.x - this.last.x;
        const dy = p.y - this.last.y;
        const n = Math.min(30, Math.floor(Math.hypot(dx, dy) / (r * 0.3)));
        for (let i = 1; i < n; i++) this.addDrop(this.last.x + (dx * i) / n, this.last.y + (dy * i) / n, r, 2600);
      }
      this.addDrop(p.x, p.y, r, 2600);
      this.last = p;
      this.style.setProperty('--k-px', (p.x / this.w - 0.5).toFixed(3));
      this.style.setProperty('--k-py', (p.y / this.h - 0.5).toFixed(3));
      this.kick();
    }

    onDown(e) {
      const p = this.point(e);
      this.lastActivity = performance.now();
      this.last = p;
      this.splash(p.x, p.y, 1);
    }

    splash(x, y, k) {
      const r = this.radius();
      this.addDrop(x, y, r * 2.2 * k, 3400);
      const n = Math.round(7 * k);
      for (let i = 0; i < n; i++) {
        const a = Math.random() * Math.PI * 2;
        const d = r * (1.4 + Math.random() * 1.8) * k;
        this.addDrop(x + Math.cos(a) * d, y + Math.sin(a) * d, r * (0.25 + Math.random() * 0.4), 2400 + Math.random() * 1400);
      }
      if (!reducedMotion.matches) this.ripples.push({ x, y, t: performance.now(), max: r * 4.2 * k, life: 1100 });
      this.kick();
    }

    burst() {
      if (this.w) this.splash(this.w / 2, this.h / 2, 2.2);
    }

    // Petit passage d'eau à l'arrivée pour montrer l'effet.
    intro() {
      this.introDone = true;
      if (reducedMotion.matches) return;
      const dur = 1300;
      let start = 0;
      const step = (now) => {
        if (!start) start = now;
        const t = (now - start) / dur;
        if (t > 1 || !this.inited) return;
        const r = this.radius();
        this.addDrop(this.w * (0.06 + 0.88 * t), this.h * (0.5 + 0.22 * Math.sin(t * Math.PI * 2)), r * 1.1, 2200);
        this.kick();
        requestAnimationFrame(step);
      };
      setTimeout(() => requestAnimationFrame(step), 350);
    }

    kick() {
      if (!this.raf && this.inited && this.visible && this.w) {
        this.raf = requestAnimationFrame(() => this.frame());
      }
    }

    frame() {
      this.raf = 0;
      const now = performance.now();
      const { ctx, mctx, lctx, ms } = this;

      // Quelques gouttes de temps en temps quand personne n'interagit.
      if (!reducedMotion.matches && now - this.lastActivity > 2600 && now > this.nextRain) {
        const r = this.radius();
        this.addDrop(this.w * (0.08 + Math.random() * 0.84), this.h * (0.1 + Math.random() * 0.8), r * (0.7 + Math.random() * 0.6), 2600);
        this.nextRain = now + 500 + Math.random() * 700;
      }

      this.drops = this.drops.filter((d) => now - d.t < d.life);
      mctx.setTransform(1, 0, 0, 1, 0, 0);
      mctx.clearRect(0, 0, this.mask.width, this.mask.height);
      for (const d of this.drops) {
        const age = (now - d.t) / d.life;
        const grow = easeOut(clamp((now - d.t) / 260, 0, 1));
        const rr = d.r * (0.5 + 0.5 * grow) * ms;
        mctx.globalAlpha = Math.pow(1 - age, 1.6);
        mctx.drawImage(BRUSH, d.x * ms - rr, d.y * ms - rr, rr * 2, rr * 2);
      }
      mctx.globalAlpha = 1;

      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      ctx.drawImage(this.base, 0, 0, this.canvas.width, this.canvas.height);

      if (this.drops.length) {
        lctx.globalCompositeOperation = 'source-over';
        lctx.clearRect(0, 0, this.layer.width, this.layer.height);
        lctx.drawImage(this.pattern, 0, 0, this.layer.width, this.layer.height);
        lctx.globalCompositeOperation = 'destination-in';
        lctx.imageSmoothingEnabled = true;
        lctx.drawImage(this.mask, 0, 0, this.layer.width, this.layer.height);
        ctx.drawImage(this.layer, 0, 0);
      }

      this.ripples = this.ripples.filter((rp) => now - rp.t < rp.life);
      for (const rp of this.ripples) {
        const t = (now - rp.t) / rp.life;
        ctx.beginPath();
        ctx.arc(rp.x * this.dpr, rp.y * this.dpr, Math.max(1, rp.max * easeOut(t) * this.dpr), 0, Math.PI * 2);
        ctx.strokeStyle = `rgba(255,255,255,${0.32 * (1 - t)})`;
        ctx.lineWidth = 1.5 * this.dpr;
        ctx.stroke();
      }

      if (this.drops.length || this.ripples.length || !reducedMotion.matches) this.kick();
    }
  }

  class KlinalyCursor extends HTMLElement {
    connectedCallback() {
      if (this.inited || !finePointer.matches) return;
      this.dot = this.querySelector('.k-cursor__dot');
      this.ring = this.querySelector('.k-cursor__ring');
      if (!this.dot || !this.ring) return;
      this.inited = true;
      this.x = this.y = this.rx = this.ry = -100;
      this.s = this.ts = 1;
      this.raf = 0;
      this.dataset.hidden = 'true';
      document.documentElement.classList.add('k-has-cursor');

      this.onMove = (e) => {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        this.x = e.clientX;
        this.y = e.clientY;
        if (this.dataset.hidden === 'true') {
          this.dataset.hidden = 'false';
          if (this.rx < 0) {
            this.rx = this.x;
            this.ry = this.y;
          }
        }
        this.dot.style.transform = `translate3d(${this.x}px, ${this.y}px, 0)`;
        this.loop();
      };
      this.onOver = (e) => {
        const t = e.target instanceof Element ? e.target : null;
        let state = 'default';
        if (t && t.closest('a, button, input, select, textarea, label, [data-magnetic]')) state = 'link';
        else if (t && t.closest('klinaly-fabric')) state = 'fabric';
        this.dataset.state = state;
      };
      this.onDown = () => {
        this.ts = 0.8;
        this.loop();
      };
      this.onUp = () => {
        this.ts = 1;
        this.loop();
      };
      this.onLeave = () => {
        this.dataset.hidden = 'true';
      };

      window.addEventListener('pointermove', this.onMove, { passive: true });
      document.addEventListener('pointerover', this.onOver, { passive: true });
      window.addEventListener('pointerdown', this.onDown, { passive: true });
      window.addEventListener('pointerup', this.onUp, { passive: true });
      document.documentElement.addEventListener('mouseleave', this.onLeave);
    }

    disconnectedCallback() {
      if (!this.inited) return;
      this.inited = false;
      window.removeEventListener('pointermove', this.onMove);
      document.removeEventListener('pointerover', this.onOver);
      window.removeEventListener('pointerdown', this.onDown);
      window.removeEventListener('pointerup', this.onUp);
      document.documentElement.removeEventListener('mouseleave', this.onLeave);
      document.documentElement.classList.remove('k-has-cursor');
      cancelAnimationFrame(this.raf);
      this.raf = 0;
    }

    loop() {
      if (!this.raf) this.raf = requestAnimationFrame(() => this.tick());
    }

    tick() {
      this.raf = 0;
      const k = reducedMotion.matches ? 1 : 0.2;
      this.rx += (this.x - this.rx) * k;
      this.ry += (this.y - this.ry) * k;
      this.s += (this.ts - this.s) * 0.25;
      this.ring.style.transform = `translate3d(${this.rx}px, ${this.ry}px, 0) scale(${this.s})`;
      if (Math.abs(this.x - this.rx) > 0.1 || Math.abs(this.y - this.ry) > 0.1 || Math.abs(this.ts - this.s) > 0.01) {
        this.loop();
      }
    }
  }

  // Date « AAAA-MM-JJ HH:MM » lue à l'heure de Paris.
  function parisOffsetMinutes(ts) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Paris',
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).formatToParts(new Date(ts));
    const p = {};
    parts.forEach((part) => {
      p[part.type] = part.value;
    });
    const asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    return (asUtc - ts) / 60000;
  }

  function parseParis(str) {
    const m = String(str).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2})(?:[:h](\d{2}))?)?$/);
    if (!m) return null;
    const guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    const first = guess - parisOffsetMinutes(guess) * 60000;
    return first - (parisOffsetMinutes(first) - parisOffsetMinutes(guess)) * 60000;
  }

  class KlinalyCountdown extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.target = parseParis(this.dataset.launch || '');
      if (!this.target) return;
      this.render();
      this.timer = setInterval(() => this.render(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = null;
    }

    render() {
      const ms = this.target - Date.now();
      if (ms <= 0) {
        this.hidden = true;
        clearInterval(this.timer);
        return;
      }
      const s = Math.floor(ms / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      const units = [
        [Math.floor(s / 86400), 'j'],
        [pad(Math.floor((s % 86400) / 3600)), 'h'],
        [pad(Math.floor((s % 3600) / 60)), 'min'],
        [pad(s % 60), 's'],
      ];
      const frag = document.createDocumentFragment();
      if (this.dataset.label) {
        const label = document.createElement('span');
        label.className = 'k-countdown__label';
        label.textContent = this.dataset.label;
        frag.append(label);
      }
      units.forEach(([value, unit]) => {
        const el = document.createElement('span');
        el.className = 'k-countdown__unit';
        const b = document.createElement('b');
        b.textContent = value;
        const small = document.createElement('small');
        small.textContent = unit;
        el.append(b, small);
        frag.append(el);
      });
      this.replaceChildren(frag);
      this.hidden = false;
    }
  }

  function magnetize(root) {
    if (!finePointer.matches || reducedMotion.matches || !root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-magnetic]').forEach((el) => {
      if (el.dataset.magnetized) return;
      el.dataset.magnetized = 'true';
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const dx = e.clientX - (r.left + r.width / 2);
        const dy = e.clientY - (r.top + r.height / 2);
        el.style.transform = `translate3d(${dx * 0.28}px, ${dy * 0.38}px, 0)`;
      });
      el.addEventListener('pointerleave', () => {
        el.style.transform = '';
      });
    });
  }

  const define = (name, cls) => {
    if (!customElements.get(name)) customElements.define(name, cls);
  };
  define('klinaly-fabric', KlinalyFabric);
  define('klinaly-cursor', KlinalyCursor);
  define('klinaly-countdown', KlinalyCountdown);

  magnetize(document);
  document.addEventListener('shopify:section:load', (e) => magnetize(e.target));
})();
